const errorLogger = function (error) {
  if (process.env.NODE_ENV === 'development') {
    console.log(error)
  } else {
    // Submit to error tracking service
  }
}

export default errorLogger
